import template from './project-selector.html';
import controller from './project-selector.controller';

const ProjectSelectorComponent = {
    template,
    controller,
    bindings: {
        currentId: '@',
        actionUrl: '@',
        isConfig: '@',
        gotoUrl: '@',
    },
};

export default ProjectSelectorComponent;



// WEBPACK FOOTER //
// ../widgets/project-selector/project-selector.component.js